import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [isLogging, setIsLogging] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLogging(true);

    try {
      const response = await axios.post(
        `${BACKEND_URL}/api/admin/login`,
        credentials,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      // Store token in localStorage
      localStorage.setItem('adminToken', response.data.access_token);
      
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      const errorMessage = error.response?.data?.detail || "Invalid username or password";
      toast.error('Login Failed', {
        description: errorMessage,
        duration: 5000,
      });
    } finally {
      setIsLogging(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-box">
        <div className="admin-login-header">
          <div className="admin-logo">
            <div className="admin-logo-icon">FM</div>
            <span className="admin-logo-text">FindMeAgent</span>
          </div>
          <h1 className="admin-login-title">Admin Login</h1>
          <p className="admin-login-subtitle">Access your dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="form-group">
            <label htmlFor="username" className="form-label">
              Username
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={credentials.username}
              onChange={handleInputChange}
              className="form-input"
              required
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleInputChange}
              className="form-input"
              required
              autoComplete="current-password"
            />
          </div>

          <button 
            type="submit" 
            className="admin-login-btn"
            disabled={isLogging}
          >
            {isLogging ? 'Logging in...' : 'Login'}
          </button>

          <div className="admin-login-info">
            <p className="admin-default-creds">
              Default credentials:<br/>
              Username: <code>admin</code><br/>
              Password: <code>FindMeAgent2025!</code>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
